import { daysOverdue } from './aging';

// Priority dot colour for a row.
export function priorityDot(inv, isPaid) {
  if (isPaid) return 'paid';
  if (inv.status === 'disputed') return 'disputed';
  if (inv.status === 'draft') return 'grey';
  const d = daysOverdue(inv.due_date);
  if (d == null) return 'grey';
  if (d > 0)     return 'red';
  if (d >= -7)   return 'amber';
  return 'grey';
}
